<script>
import TemplateMixin from './mixins/TemplateMixin';
import BaseGateway from './mixins/BaseGateway';
import SandboxCardInline from "./components/SandboxCardInline";

export default {
        name: "SandboxGateway",
        mixins: [
            TemplateMixin,
            BaseGateway
        ],        
        computed:{
            gateway(){
                return 'sandbox';
            },
            getBaseUrl(){
                return this.clientURL +'/billing/' + this.gateway + '/try/' + this.productData.id + '?type=' + this.productType;
            },
            childActiveComponent(){
                return 'SandboxCardInline';
            }
        },
        components: {
            SandboxCardInline        
        }
    }
</script>
